module.exports = __webpack_public_path__ + "static/scale-model-of-fresno-chaffee-zoo-in-fresno-california-d6404e56cfb421c68b74f16f1ff83319.png";